export interface PaymentScheduleCreateDto {
    title?: string | null;
    description?: string | null;

    currencyCode: string;
    totalAmount?: number | null;

    visibility: number; // DiaryVisibility enum
    category: number;   // DiaryCategory.Payment = 20

    links: {
        entityType: number;   // LinkedEntityType.Artwork = 1
        entityId: string;     // artworkId as string
        label?: string | null;
        isPrimary: boolean;
    }[];

    milestones: {
        sequenceNumber: number;
        label?: string | null;
        dueUtc: string;       // ISO UTC
        amount: number;
    }[];

    reminderOffsetsMinutes: number[];
}

export interface PaymentScheduleCreateResultDto {
    paymentScheduleId: number;
    parentDiaryItemId: number;
}

export interface ArtworkPaymentScheduleSummary {
    paymentScheduleId: number;
    parentDiaryItemId: number;
    title: string;
    currencyCode: string;
    totalAmount: number;
    totalPaid: number;
    totalOutstanding: number;
    nextDueUtc?: string | null;
    plannedMilestoneCount: number;
    paidMilestoneCount: number;
}

export interface DiaryPaymentDetailsDto {
    paymentScheduleId: number;
    scheduleTitle: string;
    currencyCode: string;

    milestoneId: number;
    sequenceNumber: number;
    milestoneLabel?: string | null;

    amount: number;
    amountPaid: number;
    amountOutstanding: number;

    milestoneStatus: number; // enum value
    paidUtc?: string | null;
}

export enum PaymentMilestoneStatus {
    Planned = 1,
    PartPaid = 2,
    Paid = 3,
    Cancelled = 4
}
export interface DiaryPaymentScheduleDto {
    paymentScheduleId: number;
    parentDiaryItemId: number;

    title?: string | null;
    currencyCode: string;

    totalAmount: number;
    totalPaid: number;
    totalOutstanding: number;

    nextDueUtc?: string | null;

    milestones: DiaryPaymentMilestoneDto[];
}

export interface DiaryPaymentMilestoneDto {
    milestoneId: number;
    diaryItemId: number;
    sequenceNumber: number;
    label?: string | null;

    dueUtc?: string | null;

    amount: number;
    amountPaid: number;
    amountOutstanding: number;

    status: PaymentMilestoneStatus;
}

export type PaymentMilestoneDisplay = {
    diaryItemId: number;
    amount: number;
    amountPaid: number;
    amountOutstanding: number;
    status: number;
};